"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const react_paginate_1 = __importDefault(require("react-paginate"));
const PER_PAGE = 24;
function Pagination({ page, onPageChange, total, perPage = PER_PAGE, }) {
    const [pages, setPages] = (0, react_1.useState)([]);
    (0, react_1.useEffect)(() => {
        const numberOfPages = Math.ceil((total || 0) / perPage);
        const pages = [];
        for (let i = 1; i <= numberOfPages; i++) {
            const newPage = {
                active: page === i,
                page: i,
            };
            pages.push(newPage);
        }
        // console.log("p", pages, PER_PAGE, perPage);
        setPages(pages);
    }, [total, page, perPage]);
    if ((pages === null || pages === void 0 ? void 0 : pages.length) < 1)
        return null;
    return (
    /* @ts-ignore */
    react_1.default.createElement(react_paginate_1.default, { breakLabel: "...", initialPage: page - 1, nextLabel: ">", onPageChange: (page) => onPageChange((page === null || page === void 0 ? void 0 : page.selected) + 1), pageRangeDisplayed: 5, pageCount: total ? total : 0, previousLabel: "<", 
        //   renderOnZeroPageCount={null}
        pageClassName: "page-item m-1", pageLinkClassName: "page-link custom-page-link", previousClassName: "page-item", previousLinkClassName: "page-link custom-previous-link", nextClassName: "page-item", nextLinkClassName: "page-link custom-next-link", breakClassName: "page-item m-1", breakLinkClassName: "page-link custom-break-link", containerClassName: "pagination", activeClassName: "active" }));
}
exports.default = Pagination;
